import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const adminNav = [
  { label: 'Overview', icon: '📊', path: '/admin/dashboard' },
  { label: 'New Bill', icon: '➕', path: '/billing' },
  { label: 'Products', icon: '📦', path: '/admin/products' },
  { label: 'Customers', icon: '👥', path: '/admin/customers' },
  { label: 'Bills', icon: '🧾', path: '/admin/bills' },
  { label: 'Employees', icon: '👤', path: '/admin/employees' },
  { label: 'Supplier Logs', icon: '🚚', path: '/admin/suppliers' },
  { label: 'Reports', icon: '📊', path: '/admin/reports' },
];
const employeeNav = [
  { label: 'New Bill', icon: '➕', path: '/billing' },
  { label: 'My Bills', icon: '🧾', path: '/employee/bills' },
  { label: 'Products', icon: '📦', path: '/employee/products' },
  { label: 'Record Payment', icon: '💳', path: '/employee/payments' },
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const navItems = user?.role === 'admin' ? adminNav : employeeNav;

  return (
    <div className="sidebar">
      <div className="sidebar-logo">
        <img src="/logo.jpg" alt="Logo" className="sidebar-logo-img" />
        <div>
          <h1>New<span>Sowtha</span></h1>
          <p>Billing Software</p>
        </div>
      </div>
      <nav className="sidebar-nav">
        <div className="sidebar-section-label">{user?.role === 'admin' ? 'Admin Panel' : 'Employee Portal'}</div>
        {navItems.map(item => (
          <button key={item.path} className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
            onClick={() => navigate(item.path)}>
            <span className="nav-icon">{item.icon}</span>
            {item.label}
          </button>
        ))}
      </nav>
      <div className="sidebar-footer">
        <div className="user-card">
          <div className="user-avatar">{user?.name?.[0]?.toUpperCase()}</div>
          <div>
            <div className="user-name">{user?.name}</div>
            <div className="user-role">{user?.role}</div>
          </div>
        </div>
        <button className="logout-btn" onClick={() => { logout(); navigate('/login'); }}>
          🚪 Sign Out
        </button>
      </div>
    </div>
  );
}
